module.exports = __webpack_public_path__ + "web/img/hcie.08202e14.png";